export default __webpack_public_path__ + "static/GT-America-Standard-Regular-83cbb5e59a6ca14307212f475ce8d4dd.woff2";